import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { environment } from 'src/environments/environment';
import { SharedModule } from '../shared/shared.module';
import { HttpInterceptorService } from './http/http-interceptor.service';
import { StoreModule } from '@ngrx/store';
import { coreReducer } from './store/auth';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { LoaderInterceptor } from './loading-interceptor/loading-interceptor.service';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    StoreModule.forRoot(coreReducer),
    StoreDevtoolsModule.instrument({ logOnly: !environment.production, maxAge: 25 })
  ],
  exports: [
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    },
  ]
})
export class CoreModule { }
